import React from "react";
import PropTypes from "prop-types";
import { Credential, CopyButton, Tooltip } from "./styles";
import { StyledMainContainer, Label } from "../styles";

const handleCopy = (e, querySelector) => {
  const element = document.getElementById(querySelector);
  const range = document.createRange();
  range.selectNodeContents(element);
  window.getSelection().removeAllRanges();
  window.getSelection().addRange(range);

  document.execCommand("copy");
  // Activate tooltip pop up
  const tooltip = e.target.querySelector("span");
  tooltip.setAttribute("style", "display: flex");

  // Deactivate tooltip pop up after 1.2 seconds
  setTimeout(() => {
    tooltip.setAttribute("style", "display: none");
  }, 1200);
};

const ClientCredentials = ({ selectedClient }) => (
  <StyledMainContainer>
    <Label>Bucket Name</Label>
    <Credential id="bucket-path">
      <span>{selectedClient.bucket_path}</span>
      <CopyButton onClick={e => handleCopy(e, "bucket-path")}>
        Copy
        <Tooltip>Copied!</Tooltip>
      </CopyButton>
    </Credential>
  </StyledMainContainer>
);

ClientCredentials.propTypes = {
  selectedClient: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    bucket_path: PropTypes.string,
    created_at: PropTypes.string,
    updated_at: PropTypes.string,
    feed_ids: PropTypes.arrayOf(PropTypes.number)
  })
};

export default ClientCredentials;
